import { useMutation } from "@tanstack/react-query";
import { IUseAddOffersHomeMutationResponse } from "../utils/types";
import axios from "axios";
import { useUploadProgress } from "../context/UploadProgressContext";

const useAddOurStory = (): IUseAddOffersHomeMutationResponse => {
  const { setUploadPercentage, setProcessing } = useUploadProgress();

  return useMutation({
    mutationFn: async (data) => {
      const url = window.location.pathname;
      const parts = url.split("/");
      const hotelcode = parts[1];

      setProcessing(true); // Start processing
      setUploadPercentage(0); // Reset progress

      const response = await axios({
        headers: {
          hotelcode,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        data: data,
        url: "/add-our-story",
        baseURL: process.env.REACT_APP_RESERVATION_API,
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          if (total) {
            const progress = Math.round((loaded * 100) / total);
            setUploadPercentage(progress);
          }
        },
      });

      // Simulate processing progress (you'll replace this with actual progress events)
      const interval = setInterval(() => {
        setUploadPercentage((prev: number) => {
          const newProgress = Math.min(prev + 5, 100);
          if (newProgress === 100) {
            clearInterval(interval);
          }
          return newProgress;
        });
      }, 500);
      return response.data;
    },
    onSettled: () => {
      setProcessing(false);
    },
  });
};

export default useAddOurStory;
